const mainColor = '#7DC058';

export const defaultTheme =
{
    token: {
        colorPrimary: mainColor,
        // colorLink: '#000',
        // colorTextBase: '#333',
        borderRadius: 3,

        // colorBgBase: '#fff',
        // colorError: '#BA2525',
        // colorText: '#fff',
        // colorTextBase: '#fff',
        // fontSize: 16,
        // sizePopupArrow: 10,
        // controlHeight: 36,
        // controlOutline: 'rgba(255,255,255,0)',
        // 其他主题配置
    },
    components: {
        Pagination: {
            itemActiveBg: mainColor,
        },
        Input: {
            //         activeBg: 'rgba(204,204,204,0.2)',
            //         activeBorderColor: mainColor,
            //         colorPrimaryText: "#fff",
            //         addonBg: '#fff',
            //         algorithm: true, // 启用算法
            //         activeShadow: 'none',
            //         errorActiveShadow: 'none',
            //         colorIcon: '#999999',
            //         colorBorder: '#999999',
            //         inputFontSize: 12,
        },
        Button: {
            //         primaryShadow: 'none',
            //         defaultShadow: 'none',
            //         contentFontSize: 13,
            //         paddingInline: 15,
            //         paddingBlock: 0,
            //         algorithm: true, // 启用算法

        },
        //     Collapse: {
        //         headerPadding: 0,
        //         contentPadding: 0
        //     },
        //     Select: {
        //         selectorBg: "rgba(0,0,0,0)",
        //         optionActiveBg: mainColor,
        //         optionSelectedColor: mainColor,
        //         optionSelectedBg: 'rgba(0,0,0,0)',

        //     },
        //     Table: {
        //         headerBg: 'rgba(204,204,204,0.2)',
        //         borderColor: 'rgba(204,204,204,0.1)',
        //         headerSplitColor: 'rgba(204,204,204,0.1)',
        //         footerBg: 'rgba(204,204,204,0)',
        //     },
        Tabs: {
            itemColor: "#000",
            titleFontSizeLG: 16,
        },
        //     Switch: {
        //         trackMinWidth: 75
        //     },
        //     DatePicker: {
        //         cellActiveWithRangeBg: 'rgba(204,204,204,0.2)',
        //         inputFontSize: 14
        //     }

    },
    cssVar: true,
}
